// React
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import jwtDecode from "jwt-decode"

// Components
// Hooks and Redux
import { useAppSelector } from "../../../redux/hooks"

// MUI Components
import { Box, Button, Grid, Typography } from "@mui/material"
import {
  GridCellParams,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  DataGrid,
  enUS,
} from "@mui/x-data-grid"
import theme from "../../../styles/theme"
import { thTHGrid } from "../../../@types/DataGridLocaleText"

// Utils
import { useTranslation } from "react-i18next"
import * as XLSX from "xlsx"

// Styles
import CircularProgress from "@mui/material/CircularProgress"
import Swal from "sweetalert2"

// Services
import {
  getAllActiveCountryNationalID,
  getAllActiveCountry,
  // getAllActivePrefix, //เปลี่ยนมาใช้ useAppSelector
  getAllActiveReligion,
  getAllActiveMaritalStatus,
  getAllActivePayGrade,
  getAllActiveIncentiveGroup,
  getAllActiveWorkSchedule,
  getAllActiveHolidaySchedule,
  getAllActiveWorkGroup,
  getAllActiveBank,
  getAllActivePayGroup,
  // getAllActiveCompany, //เปลี่ยนมาใช้ useAppSelector
  getAllActiveNationalIDCardType,
} from "../../../services/MasterDataService"
// import { getAllSites } from "../../../services/SiteService" //เปลี่ยนมาใช้ useAppSelector
import { validateThaiCitizenID } from "../../../utils/validate"

import { addExcelECData } from "../../../services/ExcelECService"
import THAProvinceJSON from "../../../services/REGION_THA/Province.json"

// Types
import { CompanyInter } from "../../../@types/ECData.type"
import { Site } from "../../../@types"

interface IProcessResult {
  id: string
  duplicate_NationId: boolean
  first_NameTH: string
  last_NameTH: string
  nationalID: boolean
  countryOfNationalID: boolean
  nationality: boolean
  NationalIDCardType: boolean
  countryOfBirth: boolean

  //Profile
  prefixName: boolean
  firstNameTH: boolean
  lastNameTH: boolean
  firstNameEN: boolean
  lastNameEN: boolean
  dateOfBirth: boolean
  underAge18: boolean
  gender: boolean
  maritalStatus: boolean
  religion: boolean
  phoneNumber: boolean

  //Job
  hireDate: boolean
  position: boolean
  jobRelationshipEmail: boolean
  company: boolean
  payGrade: boolean
  incentiveGroup: boolean
  site_id: boolean

  workSchedule: boolean
  holidaySchedule: boolean
  workgroup: boolean
  payGroup: boolean

  //bank
  bankAccountNumber: boolean
  bank: boolean

  //Address Legal
  LegalCountry: boolean
  LegalHouseNumber: boolean
  LegalMoo: boolean
  LegalSubDistrict: boolean
  LegalDistrict: boolean
  LegalProvince: boolean
  LegalPostalcode: boolean
  SameLegal: boolean

  //Address Mailing
  MailingCountry: boolean
  MailingHouseNumber: boolean
  MailingMoo: boolean
  MailingSubDistrict: boolean
  MailingDistrict: boolean
  MailingProvince: boolean
  MailingPostalCode: boolean

  TimeReporterType: boolean
  Utilized: boolean

  error: boolean
  errorRows: any
}

interface IExcelsData {
  amount_101: string
  amount_102: string
  amount_103_1: string
  amount_125: string
  amount_128: string
  amount_133: string
  amount_163: string
  bank: string
  candidate_email: string
  bank_account_number: string
  company: string
  contract_end_date: string
  contract_start_date: string
  country_of_birth: string
  country_of_national_id: string
  date_of_birth: string
  prefix: string
  first_name_en: string
  first_name_th: string
  gender: string
  hire_date: string
  holiday_schedule: string
  incentive_group: string
  job_relationship_email: string
  last_name_en: string
  last_name_th: string
  legal_building: string
  legal_country: string
  legal_district: string
  legal_floor: string
  legal_house_number: string
  legal_lane: string
  legal_moo: string
  legal_postal_code: string
  legal_province: string
  legal_room_no: string
  legal_street: string
  legal_sub_district: string
  legal_village: string
  mailing_bluiding: string
  mailing_country: string
  mailing_district: string
  mailing_floor: string
  mailing_house_number: string
  mailing_lane: string
  mailing_moo: string
  mailing_postal_code: string
  mailing_province: string
  mailing_room_no: string
  mailing_street: string
  mailing_sub_district: string
  mailing_village: string
  marital_status: string
  national_id: string
  national_id_card_type: string
  nationality: string
  pay_grade: string
  pay_group: string
  phone_number: string
  position: string
  registered_sso: string
  religion: string
  same_as_legal: string
  sso_hospital: string
  time_reporter_type: string
  utilized_: string
  work_schedule: string
  workgroup: string
  site_id: string
}

const UploadExcel = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { rolesite } = useAppSelector((state) => state.user)
  const [isLoggedIn, setIsLoggedIn] = React.useState(false)
  const [parsedToken, setParsedToken] = useState<any | null>(null)
  //new
  const [importExcelData, setImportExcelDataData] = useState<IExcelsData[]>([])
  const [importCheckingData, setImportCheckingData] = useState<
    IProcessResult[]
  >([])
  const [loadingUpload, setLoadingUpload] = useState<boolean>(false)
  //Master Data
  // const [countryNationalList, setCountryNationalList] = useState<
  //   { country_code: string; country_name: string }[]
  // >([])
  // const [countryList, setCountryList] = useState<
  //   { country_code: string; country_name: string }[]
  // >([])
  // เปลี่ยนมาใช้ useAppSelector
  // const [prefixList, setPrefixList] = useState<
  //   { external_code: string; label: string }[]
  // >([])
  const {
    prefixes: prefixList,
    companies: companyList,
    sites: sitesData,
    countriesNationalID: countryNationalList,
    countries: countryList,
  } = useAppSelector((state) => state.masterData)

  const [religionList, setReligionList] = useState<
    { external_code: string; label_en: string; label_th: string }[]
  >([])
  const [maritalList, setMaritalList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [payGradeList, setPayGradeList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [incentiveGroupList, setIncentiveGroupList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [workScheduleList, setWorkScheduleList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [holidayScheduleList, setHolidayScheduleList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [workGroupList, setWorkGroupList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [bankList, setBankList] = useState<
    { bank_code: string; bank_name: string }[]
  >([])
  const [payGroupList, setPayGroupList] = useState<
    { pay_group_id: string; label: string }[]
  >([])
  // เปลี่ยนมาใช้ useAppSelector
  // const [companyList, setCompanyList] = useState<
  //   { company_code: string; company_name: string }[]
  // >([])
  const [nationalIDCardTypeList, setNationalIDCardTypeList] = useState<
    { external_code: string; label: string }[]
  >([])
  // เปลี่ยนมาใช้ useAppSelector
  // const [sitesData, setSitesData] = useState<Site[]>([])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: `${t("ID card number")}`,
      width: 200,
      valueGetter: (params: GridCellParams) => params.row.id,
      renderCell: (params: GridCellParams) => params.row.id ?? "-",
    },
    {
      field: "first_name_th",
      headerName: `${t("First name (Thai language)")}`,
      width: 200,
      valueGetter: (params: GridCellParams) => params.row.first_NameTH,
      renderCell: (params: GridCellParams) => params.row.first_NameTH ?? "-",
    },
    {
      field: "last_name_th",
      headerName: `${t("Last name (Thai language)")}`,
      width: 200,
      valueGetter: (params: GridCellParams) => params.row.last_NameTH,
      renderCell: (params: GridCellParams) => params.row.last_NameTH ?? "-",
    },
    {
      field: "errorRows",
      headerName: `${t("text_Error_validate_excel")}`,
      renderHeader: (params) => (
        <span style={{ color: "red" }}>{t("text_Error_validate_excel")}</span>
      ),
      width: 500,
      valueGetter: (params: GridCellParams) => params.row.errorRows.join(" , "),
      renderCell: (params: GridCellParams) =>
        params.row.errorRows.join(" , ") ?? "-",
    },
  ]

  useEffect(() => {
    try {
      if (localStorage.getItem("access_token") !== null) {
        setParsedToken(jwtDecode(localStorage.access_token))
        setIsLoggedIn(true)
      } else {
        setIsLoggedIn(false)
      }
    } catch (error) {
      setIsLoggedIn(false)
    }
  }, [])

  useEffect(() => {
    const fetchNationalIDCardType = async () => {
      try {
        const response = await getAllActiveNationalIDCardType("Active")

        if (response.data?.success) {
          const nationalIDCardTypeData = response?.data?.nationalIDCardTypes

          setNationalIDCardTypeList(nationalIDCardTypeData)
        }
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    // เปลี่ยนมาใช้ useAppSelector
    // const fetchSites = async () => {
    //   try {
    //     const response = await getAllSites()

    //     if (response.data?.success) {
    //       const sitesData = response.data?.sites

    //       setSitesData(sitesData)
    //     }
    //   } catch (error) {
    //     navigate("/servererror", { replace: true })
    //   }
    // }

    // const fetchAllActiveCountryNationalId = async () => {
    //   try {
    //     const response = await getAllActiveCountryNationalID("Active")

    //     if (response.data?.success) {
    //       console.log(
    //         "response?.data?.countryNational   ",
    //         response?.data?.countryNational
    //       )
    //       setCountryNationalList(response?.data?.countryNational)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     navigate("/servererror", { replace: true })
    //   }
    // }
    // const fetchAllActiveCountry = async () => {
    //   try {
    //     const response = await getAllActiveCountry("Active")
    //     if (response.data?.success) {
    //       setCountryList(response?.data?.countries)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     navigate("/servererror", { replace: true })
    //   }
    // }
    // เปลี่ยนมาใช้ useAppSelector
    // const fetchAllActivePrefix = async () => {
    //   try {
    //     const response = await getAllActivePrefix("Active")
    //     if (response.data?.success) {
    //       setPrefixList(response?.data?.prefix)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     navigate("/servererror", { replace: true })
    //   }
    // }
    const fetchAllActiveReligion = async () => {
      try {
        const response = await getAllActiveReligion("Active")
        if (response.data?.success) {
          setReligionList(response?.data?.religions)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    const fetchAllActiveMaritalStatus = async () => {
      try {
        const response = await getAllActiveMaritalStatus("Active")

        if (response.data?.success) {
          setMaritalList(response?.data?.marital_statuses)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    const fetchAllActivePayGrade = async () => {
      try {
        const response = await getAllActivePayGrade("Active")

        if (response.data?.success) {
          setPayGradeList(response?.data?.payGrades)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    const fetchAllActiveIncentiveGroup = async () => {
      try {
        const response = await getAllActiveIncentiveGroup("Active")
        if (response.data?.success) {
          setIncentiveGroupList(response?.data?.incentiveGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    const fetchAllActiveWorkSchedule = async () => {
      try {
        const response = await getAllActiveWorkSchedule("Active")

        if (response.data?.success) {
          setWorkScheduleList(response?.data?.workSchedules)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    const fetchAllActiveHolidaySchedule = async () => {
      try {
        const response = await getAllActiveHolidaySchedule("Active")

        if (response.data?.success) {
          setHolidayScheduleList(response?.data?.holidaySchedules)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    const fetchAllActiveWorkGroup = async () => {
      try {
        const response = await getAllActiveWorkGroup("Active")

        if (response.data?.success) {
          setWorkGroupList(response?.data?.workGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    const fetchAllActiveBank = async () => {
      try {
        const response = await getAllActiveBank("Active")
        if (response.data?.success) {
          setBankList(response?.data?.banks)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    const fetchAllActivePayGroup = async () => {
      try {
        const response = await getAllActivePayGroup("Active")

        if (response.data?.success) {
          setPayGroupList(response?.data?.payGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }
    // เปลี่ยนมาใช้ useAppSelector
    // const fetchAllActiveCompany = async () => {
    //   try {
    //     const response = await getAllActiveCompany(true)
    //     if (response.data?.success) {
    //       setCompanyList(response?.data?.companies)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     navigate("/servererror", { replace: true })
    //   }
    // }

    fetchAllActiveWorkSchedule()
    // fetchAllActiveCountryNationalId()
    // fetchAllActiveCountry()
    // fetchAllActivePrefix() //เปลี่ยนมาใช้ useAppSelector
    fetchAllActiveReligion()
    fetchAllActiveMaritalStatus()
    fetchAllActiveIncentiveGroup()
    fetchAllActiveHolidaySchedule()
    fetchAllActivePayGrade()
    fetchAllActiveWorkGroup()
    fetchAllActiveBank()
    fetchAllActivePayGroup()
    // fetchAllActiveCompany() //เปลี่ยนมาใช้ useAppSelector
    fetchNationalIDCardType()
    // fetchSites() //เปลี่ยนมาใช้ useAppSelector
  }, [navigate])

  const checkDuplicateID = async (data: any) => {
    const idCounts = data?.reduce((acc: any, item: IExcelsData) => {
      acc[item?.national_id] = (acc[item?.national_id] || 0) + 1
      return acc
    }, {})

    const duplicateIds = Object.entries(idCounts)
      .filter(([id, count]) => (count as number) > 1)
      .map(([id]) => id)

    return duplicateIds
  }

  // NOTE: calculateAge — ซ้ำกับ admin/PersonalInfo.tsx, EditJobDetailData.tsx, SignUp.tsx, JobAppDetail.tsx, ExcelEcDetail.tsx, FileContract.tsx ควรย้ายไปรวมใน utils/index.ts
  const calculateAge = async (dateOfBirth: string) => {
    const [day, month, year] = dateOfBirth.split("/").map(Number)
    const birthDate = new Date(year, month - 1, day)
    const today = new Date()

    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }

    return age
  }

  const mapNameCompany = (companyCode: string): string => {
    const company = companyList.find(
      (item: CompanyInter) => companyCode === item.company_code
    )
    return company
      ? `${company.company_code} - ${company.company_name}`
      : companyCode
  }
  const mapSites = (site_id: string) => {
    const data: any = sitesData.find((item: any) => site_id === item.site_id)!
    const siteText: string = data
      ? `${data?.site_name}[${data?.site_id}]`
      : site_id
    return siteText
  }

  const mapCheckSites = (site_id: string) => {
    const data: any = sitesData.find((item: any) => site_id === item.site_id)!
    const siteText: string = data ? `${data?.site_name}[${data?.site_id}]` : ""
    return siteText
  }

  useEffect(() => {
    try {
      const getFalseItem = async (obj: any) =>
        Object.keys(obj).filter((i) => obj[i] === false)
      const handleCheckFilesData = async () => {
        let importStatusData: IProcessResult[] = []

        const duplicateIds = await checkDuplicateID(importExcelData)

        for (const item of importExcelData) {
          const result: IProcessResult = {
            id: "",
            duplicate_NationId: false,
            nationalID: false,
            countryOfNationalID: false,
            nationality: false,
            NationalIDCardType: false,
            countryOfBirth: false,

            //Profile
            prefixName: false,
            firstNameTH: false,
            lastNameTH: false,
            firstNameEN: false,
            lastNameEN: false,
            first_NameTH: "",
            last_NameTH: "",
            dateOfBirth: false,
            underAge18: false,
            gender: false,
            maritalStatus: false,
            religion: false,
            phoneNumber: false,

            //Job
            hireDate: false,
            position: false,
            jobRelationshipEmail: false,
            company: false,
            payGrade: false,
            incentiveGroup: false,
            site_id: false,

            workSchedule: false,
            holidaySchedule: false,
            workgroup: false,
            payGroup: false,

            // //bank
            bankAccountNumber: false,
            bank: false,

            //Address Legal
            LegalCountry: false,
            LegalHouseNumber: false,
            LegalMoo: false,
            LegalSubDistrict: false,
            LegalDistrict: false,
            LegalProvince: false,
            LegalPostalcode: false,
            SameLegal: false,

            //Address Mailing
            MailingCountry: false,
            MailingHouseNumber: false,
            MailingMoo: false,
            MailingSubDistrict: false,
            MailingDistrict: false,
            MailingProvince: false,
            MailingPostalCode: false,

            TimeReporterType: false,
            Utilized: false,

            error: true,
            errorRows: [],
          }

          result.id = item?.national_id

          //check nationalID
          const regexNumber = /^[0-9]+$/

          result.nationalID =
            item?.national_id &&
            item?.national_id?.length === 13 &&
            regexNumber.test(item?.national_id)
              ? item.national_id_card_type === "tni" &&
                item?.national_id?.length === 13
                ? validateThaiCitizenID(item?.national_id) // true || false
                : true
              : false

          //check duplicate_NationId
          result.duplicate_NationId =
            duplicateIds?.length > 0
              ? duplicateIds.indexOf(item?.national_id) >= 0
                ? false
                : true
              : true

          const checkCountryNationalID =
            item?.country_of_national_id &&
            item?.country_of_national_id.length === 3
              ? item?.country_of_national_id === "THA"
              : false

          result.countryOfNationalID = checkCountryNationalID

          //check nationality
          const checkNationality =
            item?.nationality && item?.nationality.length === 3
              ? countryNationalList.filter(
                  (i) => i.country_code === item?.nationality
                ).length > 0
              : false
          result.nationality = checkNationality

          //check national_id_card_type

          const checkNationalIdType =
            item?.national_id_card_type &&
            item?.national_id_card_type.length === 3
              ? nationalIDCardTypeList?.filter(
                  (i) => i.external_code === item?.national_id_card_type
                ).length > 0
              : false

          result.NationalIDCardType = checkNationalIdType

          //check Country of Birth
          const checkCountryBirth =
            item?.country_of_birth && item?.country_of_birth.length > 0
              ? countryList.filter(
                  (i) => i.country_code === item?.country_of_birth
                ).length > 0
              : false
          result.countryOfBirth = checkCountryBirth

          //check prefix name
          const checkPrefix =
            item?.prefix && item?.prefix.length > 0
              ? prefixList.filter((i) => i.external_code === item?.prefix)
                  .length > 0
              : false
          result.prefixName = checkPrefix
          result.firstNameTH =
            item?.first_name_th && item?.first_name_th.length > 0 ? true : false
          result.lastNameTH =
            item?.last_name_th && item?.last_name_th.length > 0 ? true : false
          result.first_NameTH =
            item?.first_name_th && item?.first_name_th.length
              ? item?.first_name_th
              : " - "
          result.last_NameTH =
            item?.last_name_th && item?.last_name_th.length
              ? item?.last_name_th
              : " - "
          result.firstNameEN =
            item?.first_name_en && item?.first_name_en.length > 0 ? true : false
          result.lastNameEN =
            item?.last_name_en && item?.last_name_en.length > 0 ? true : false
          result.phoneNumber =
            item?.phone_number && item?.phone_number.length === 10
              ? true
              : false

          result.dateOfBirth =
            item?.date_of_birth &&
            item?.date_of_birth.length > 0 &&
            dateRegex.test(item?.date_of_birth)
              ? true
              : false

          //underAge18
          const checkAge = await calculateAge(item.date_of_birth)
          result.underAge18 =
            item?.date_of_birth &&
            item?.date_of_birth.length > 0 &&
            checkAge >= 18
              ? true
              : false

          result.gender =
            item?.gender &&
            item?.gender.length > 0 &&
            (item?.gender === "F" || item?.gender === "M")
              ? true
              : false

          //check marital_status
          const checkMaritalStatus =
            item?.marital_status && item?.marital_status.length > 0
              ? maritalList.filter(
                  (i) => i.external_code === item?.marital_status
                ).length > 0
              : false
          result.maritalStatus = checkMaritalStatus

          //check religion
          const checkReligion =
            item?.religion && item?.religion.length > 0
              ? religionList.filter((i) => i.external_code === item?.religion)
                  .length > 0
              : false
          result.religion = checkReligion
          //Job
          result.hireDate =
            item?.hire_date &&
            item?.hire_date.length > 0 &&
            dateRegex.test(item?.hire_date)
              ? true
              : false
          result.position =
            item?.position && item?.position.length === 8 ? true : false
          result.jobRelationshipEmail =
            item?.job_relationship_email &&
            item?.job_relationship_email.length > 0 &&
            item?.job_relationship_email.split("@")[1] === "betagro.com"
              ? true
              : false
          //check checkCompany
          const checkCompany =
            item?.company && item?.company.length > 0
              ? companyList.filter((i) => i.company_code === item?.company)
                  .length > 0
              : false
          result.company = checkCompany

          //check Pay Grade
          const checkPayGrade =
            item?.pay_grade && item?.pay_grade.length > 0
              ? payGradeList.filter((i) => i.external_code === item?.pay_grade)
                  .length > 0
              : false
          result.payGrade = checkPayGrade

          //check incentive_group
          const checkIncentiveGroup =
            item?.incentive_group && item?.incentive_group.length > 0
              ? incentiveGroupList.filter(
                  (i) => i.external_code === item?.incentive_group
                ).length > 0
              : false
          result.incentiveGroup = checkIncentiveGroup

          //check work Schedule
          const checkWorkSchedule =
            item?.work_schedule && item?.work_schedule.length > 0
              ? workScheduleList.filter(
                  (i) => i.external_code === item?.work_schedule
                ).length > 0
              : false
          result.workSchedule = checkWorkSchedule
          //check holidaySchedule
          const checkHolidaySchedule =
            item?.holiday_schedule && item?.holiday_schedule.length > 0
              ? holidayScheduleList.filter(
                  (i) => i.external_code === item?.holiday_schedule
                ).length > 0
              : false
          result.holidaySchedule = checkHolidaySchedule

          //check work group
          const checkWorkGroup =
            item?.workgroup && item?.workgroup.length > 0
              ? workGroupList.filter((i) => i.external_code === item?.workgroup)
                  .length > 0
              : false
          result.workgroup = checkWorkGroup

          //check payGroup
          const checkPayGroup =
            item?.pay_group && item?.pay_group.length > 0
              ? payGroupList.filter((i) => i.pay_group_id === item?.pay_group)
                  .length > 0
              : false
          result.payGroup = checkPayGroup

          //check bank
          const checkBank =
            item?.bank &&
            item?.bank?.length > 0 &&
            item?.bank_account_number &&
            item?.bank_account_number?.toString().length === 10
              ? bankList.filter((i) => i.bank_code === item?.bank).length > 0
              : item?.bank === null && item?.bank_account_number === null
              ? true
              : false

          result.bank = checkBank

          //bank
          result.bankAccountNumber =
            item?.bank &&
            item?.bank?.length > 0 &&
            item?.bank_account_number &&
            item?.bank_account_number.toString().length === 10
              ? true
              : item?.bank === null && item?.bank_account_number === null
              ? true
              : false

          const siteCheck =
            item?.site_id && item?.site_id.toString().length > 0
              ? rolesite.indexOf(item?.site_id) >= 0
              : false
          result.site_id = siteCheck

          const checkCountryLegal =
            item?.legal_country && item?.legal_country.length === 3
              ? item?.legal_country === "THA"
              : false
          result.LegalCountry = checkCountryLegal

          result.LegalHouseNumber =
            item?.legal_house_number && item?.legal_house_number.length > 0
              ? true
              : false
          result.LegalMoo =
            item?.legal_moo && item?.legal_moo.length > 0 ? true : false
          result.LegalSubDistrict =
            item?.legal_sub_district && item?.legal_sub_district.length > 0
              ? true
              : false
          result.LegalDistrict =
            item?.legal_district && item?.legal_district.length > 0
              ? true
              : false

          const jsonProvince = THAProvinceJSON?.filter(
            (province) =>
              province.external_code.toString() === item?.legal_province
          )

          result.LegalProvince =
            item?.legal_province &&
            item?.legal_province.length > 0 &&
            jsonProvince?.length > 0
              ? true
              : false
          result.LegalPostalcode =
            item?.legal_postal_code && item?.legal_postal_code.length === 5
              ? true
              : false
          result.SameLegal =
            item?.same_as_legal &&
            item?.same_as_legal.length > 0 &&
            (item?.same_as_legal === "No" || item?.same_as_legal === "Yes")
              ? true
              : false

          const checkCountryMailing =
            item?.mailing_country && item?.mailing_country.length === 3
              ? item?.mailing_country === "THA"
              : false
          result.MailingCountry = checkCountryMailing

          result.MailingHouseNumber =
            item?.mailing_house_number && item?.mailing_house_number.length > 0
              ? true
              : false
          result.MailingMoo =
            item?.mailing_moo && item?.mailing_moo.length > 0 ? true : false
          result.MailingSubDistrict =
            item?.mailing_sub_district && item?.mailing_sub_district.length > 0
              ? true
              : false
          result.MailingDistrict =
            item?.mailing_district && item?.mailing_district.length > 0
              ? true
              : false

          const jsonMailProvince = THAProvinceJSON?.filter(
            (province) =>
              province.external_code.toString() === item?.mailing_province
          )
          result.MailingProvince =
            item?.mailing_province &&
            item?.mailing_province.length > 0 &&
            jsonMailProvince?.length > 0
              ? true
              : false
          result.MailingPostalCode =
            item?.mailing_postal_code && item?.mailing_postal_code.length === 5
              ? true
              : false
          result.TimeReporterType =
            item?.time_reporter_type &&
            item?.time_reporter_type.length > 0 &&
            (item?.time_reporter_type === "Yes" ||
              item?.time_reporter_type === "No")
              ? true
              : false
          result.Utilized =
            item?.utilized_ &&
            item?.utilized_.length > 0 &&
            (item?.utilized_ === "Y" || item?.utilized_ === "N")
              ? true
              : false

          const checkError = await getFalseItem(result)
          result.errorRows = checkError
          result.error = checkError && checkError.length > 0 ? true : false
          importStatusData.push(result)
        }

        const errData =
          importStatusData && importStatusData.length > 0
            ? importStatusData.filter((i) => i.error === true)
            : []
        if (importStatusData && errData.length > 0) {
          setLoadingUpload(false)
          setImportCheckingData(errData)
        } else {
          setLoadingUpload(false)
          setImportCheckingData([])

          Swal.fire({
            icon: "question",
            title: `${t("Are you sure?")}`,
            html: `${t(
              "text_confirm_add_to_table_ec"
            )}&nbsp&nbsp<div class="MuiChip-root MuiChip-outlined MuiChip-sizeMedium MuiChip-colorDefault MuiChip-outlinedDefault css-1i5jzc9-MuiChip-root"><span class="MuiChip-label MuiChip-labelMedium css-6od3lo-MuiChip-label">
                     </span></div> <br>${t("text_confirm_add_to_table_ec_2")}`,
            showCancelButton: true,
            confirmButtonColor: "#43A047",
            cancelButtonText: `${t("Cancel")}`,
            confirmButtonText: `${t("Confirm")}`,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              const uploadStatus = await addExcelECData(importExcelData)
              if (
                uploadStatus?.data?.status === 200 &&
                uploadStatus?.data?.success === true
              ) {
                Swal.fire({
                  icon: "success",
                  title: `${t("Success")}`,
                  text: `${t("Update EC data successfully")}`,
                  confirmButtonText: `${t("ok")}`,
                }).then(() => {
                  window.location.assign("/admin/hiring/ec")
                })
              } else {
                const idCard = uploadStatus?.data?.result?.errors
                  ? uploadStatus?.data?.result?.errors
                  : uploadStatus?.data?.msgStatus === 402
                  ? uploadStatus?.data?.result?.national_id
                  : ""
                const company =
                  uploadStatus?.data && uploadStatus?.data?.dataErr[0]
                    ? mapNameCompany(uploadStatus?.data?.dataErr[0]?.company)
                    : ""
                const site =
                  uploadStatus?.data && uploadStatus?.data?.dataErr[0]
                    ? mapSites(uploadStatus?.data?.dataErr[0]?.site_id)
                    : ""

                const created_by =
                  uploadStatus?.data?.dataErr[0]?.created_by?.split(
                    "BTG/"
                  )[1] || ""

                const typeEC =
                  uploadStatus?.data &&
                  uploadStatus?.data?.dataErr[0]?.type === "excel-ec"
                    ? "text_idcard_applicant_still_employee_Excel"
                    : "text_idcard_applicant_still_employee"

                const textResponse = `${t("ECSomefailed")}<br><br><div>
<span>${t("text_idcard_applicant_still_number")}&nbsp${idCard}&nbsp <br>${t(
                  typeEC
                )}</span><br>
<span>${t(
                  "text_applicant_still_employee"
                )}&nbsp${company}&nbsp${site}</span><br>
                
<span>${t("text_recruiter")}&nbsp : ${created_by}</span><br>
</div>`

                const text =
                  uploadStatus?.data?.msgStatus === 401
                    ? textResponse
                    : uploadStatus?.data?.msgStatus === 402 &&
                      uploadStatus?.data?.result?.duplicate_type === "email"
                    ? `${t("ECSomefailed")}<br><br><div>${idCard} ${t(
                        "text_email_already_in_use"
                      )}</div>`
                    : uploadStatus?.data?.msgStatus === 402 &&
                      uploadStatus?.data?.result?.duplicate_type === "phone"
                    ? `${t("ECSomefailed")}<br><br><div>${idCard} ${t(
                        "text_phone_already_in_use"
                      )}</div>`
                    : ""

                Swal.fire({
                  icon: "error",
                  html: text,
                  confirmButtonColor: "#43A047",
                  confirmButtonText: "OK!",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                })
              }
            }
          })
        }
      }

      if (importExcelData && importExcelData.length > 0) {
        handleCheckFilesData()
      }
    } catch (error) {
      navigate("/servererror", { replace: true })
    }
  }, [
    importExcelData,
    navigate,
    countryNationalList,
    countryList,
    prefixList,
    maritalList,
    religionList,
    companyList,
    payGradeList,
    incentiveGroupList,
    workScheduleList,
    holidayScheduleList,
    workGroupList,
    payGroupList,
    bankList,
    t,
  ])

  const handleFileUpload = (e: any) => {
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.onload = (event: any) => {
      const data = new Uint8Array(event.target.result)

      const workbook = XLSX.read(data, { type: "array" })
      const sheetName = workbook.SheetNames[0]
      const sheet = workbook.Sheets[sheetName]
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 })
      if (jsonData && jsonData?.length > 1) {
        const headerKey = jsonData.length > 0 ? jsonData[0] : []
        let result: any = []

        for (let rowIndex = 1; rowIndex < jsonData.length; rowIndex++) {
          const currentRow = jsonData.length > 0 ? jsonData[rowIndex] : []

          if (Array.isArray(headerKey) && Array.isArray(currentRow)) {
            const rowObj: any = {}
            for (let colIndex = 0; colIndex < headerKey.length; colIndex++) {
              const validateIdex = currentRow[colIndex]
                ? String(currentRow[colIndex])
                : null
              rowObj[
                headerKey[colIndex]
                  .replace(/\(THA\)|\(Y\/N\)|\./g, "")
                  .replace(/\s+/g, "_")
                  .toLowerCase()
              ] = validateIdex
            }
            rowObj.created_by = isLoggedIn
              ? jwtDecode<any>(localStorage.getItem("access_token")!).Username
              : parsedToken && parsedToken?.Username
              ? parsedToken.Username
              : null

            result.push(rowObj)
          }
        }

        setLoadingUpload(true)
        setImportExcelDataData(result)
      } else {
        Swal.fire({
          icon: "error",
          title: `${t("Oops! Internal Server Error")}`,
          text: `${t("Text_Error_Exels_null")}`,
          confirmButtonText: `${t("ok")}`,
        }).then(() => {
          setLoadingUpload(false)
        })
      }
    }

    reader.readAsArrayBuffer(file)
  }

  // NOTE: CustomToolbar — ซ้ำกันทุกหน้าที่มี DataGrid (37+ ไฟล์) ควรย้ายไปรวมใน components/common/DataGridToolbar.tsx
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    )
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "70px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} lg={8}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              {t("HiringJobExcel")}
            </Typography>
          </Grid>

          <Grid item xs={6} lg={2}>
            <div className="custom-file-upload-excel">
              <a
                href="../../../assets/file/template_update.xlsx"
                download="template.xlsx"
                style={{
                  alignItems: "center",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                {t("Template")}
              </a>
            </div>
          </Grid>

          <Grid item xs={6} lg={2}>
            <div className={`custom-file-upload-excel`}>
              {t("text_button_upload_excel")}
              <input
                type="file"
                id="fileInput"
                className="file-input"
                accept="image/png, image/jpeg, .pdf, .doc,.docx, .xls, .xlsx"
                onChange={(event) => {
                  handleFileUpload(event)
                }}
                onClick={(e) => ((e.target as HTMLInputElement).value = "")}
              />
            </div>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ width: "100%", marginTop: 3, paddingX: 3 }}>
        {loadingUpload ? (
          <Box display="flex" justifyContent="center" gap={2}>
            <CircularProgress size={100} />
            <Typography align="center">{t("Loading")}...</Typography>
          </Box>
        ) : importCheckingData.length === 0 ? (
          <Typography align="center">{t("No data")}</Typography>
        ) : (
          <>
            <Box display="inline-grid" sx={{ width: "100%" }}>
              <DataGrid
                getRowId={(row) => (row?.id ? row?.id : "-")}
                rows={importCheckingData}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                  // Column pinning ถูกตัดออก: pinnedColumns เป็นฟีเจอร์ของ DataGridPro เท่านั้น ไม่มีใน DataGrid ฟรี (ดูรายงาน MUI Pro Removal)
                }}
                pagination
                pageSizeOptions={[10, 20, 30, 40, 50]}
                getRowHeight={() => 50}
                disableRowSelectionOnClick
                sx={{
                  "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
                    {
                      outline: "none !important",
                    },
                  fontSize: 13,
                }}
                slots={{
                  toolbar: CustomToolbar,
                }}
                slotProps={{
                  filterPanel: {
                    filterFormProps: {
                      logicOperatorInputProps: {
                        variant: "outlined",
                        size: "small",
                      },
                      columnInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                      },
                      operatorInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                      },
                      valueInputProps: {
                        InputComponentProps: {
                          variant: "outlined",
                          size: "small",
                        },
                      },
                      deleteIconProps: {
                        sx: {
                          "& .MuiSvgIcon-root": { color: "#d32f2f" },
                        },
                      },
                    },
                    sx: {
                      "& .MuiDataGrid-filterForm": { p: 2 },
                      "& .MuiDataGrid-filterForm:nth-of-type(even)": {
                        backgroundColor: () =>
                          theme.palette.mode === "dark" ? "#444" : "#f5f5f5",
                      },
                      "& .MuiDataGrid-filterFormLogicOperatorInput": { mr: 2 },
                      "& .MuiDataGrid-filterFormColumnInput": {
                        mr: 2,
                        width: 150,
                      },
                      "& .MuiDataGrid-filterFormOperatorInput": { mr: 2 },
                      "& .MuiDataGrid-filterFormValueInput": { width: 200 },
                    },
                  },
                }}
                localeText={
                  i18n.language === "en"
                    ? enUS.components.MuiDataGrid.defaultProps.localeText
                    : thTHGrid
                }
                // unstable_headerFilters
              />
            </Box>
          </>
        )}
      </Box>
    </>
  )
}

export default UploadExcel
